export function tableFiltersApplied(columnKey, filters) {
    if (!!filters[columnKey]) {
        if (filters[columnKey] !== "") {
            return true
        }
    }
    return false
}
